import * as React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from '../../Checkbox/Checkbox';
import { SortModel } from '../utils/DataTableQueryProvider/DataTableQuery.types';
import { SystemIconButton } from '../../Icon';

export enum UtilityColumns {
  EXPANDER = 'expander',
  SELECTION = 'selection',
  MENU = 'menu',
  MENU_V2 = '[menu]'
}

export const menuColumnsIds: UtilityColumns[] = [UtilityColumns.MENU, UtilityColumns.MENU_V2];

export const utilityColumnsIds: UtilityColumns[] = [UtilityColumns.EXPANDER, UtilityColumns.SELECTION];

export const expandedColumn: ColumnDef<object, SortModel> = {
  id: UtilityColumns.EXPANDER,
  enableResizing: false,
  meta: {
    defaultWidth: 65,
    blockColumnHiding: true,
    ellipsisOnOverflow: false
  },
  header: ({ table }) => {
    const isExpanded = table.getIsAllRowsExpanded();
    const onClick = table.getToggleAllRowsExpandedHandler();
    return isExpanded ? (
      <SystemIconButton dataTest="expand-header" size="small" onClick={onClick} iconName="keyboard_arrow_down" />
    ) : (
      <SystemIconButton dataTest="expand-header" size="small" onClick={onClick} iconName="keyboard_arrow_right" />
    );
  },
  cell: ({ row }) => {
    const canExpand = row.getCanExpand();
    const isExpanded = row.getIsExpanded();
    const onClick = row.getToggleExpandedHandler();
    return canExpand ? (
      isExpanded ? (
        <SystemIconButton size="small" onClick={onClick} dataTest="expanded-cell" iconName="keyboard_arrow_down" />
      ) : (
        <SystemIconButton size="small" onClick={onClick} dataTest="expanded-cell" iconName="keyboard_arrow_right" />
      )
    ) : null;
  }
};

export const selectionColumn: ColumnDef<object, SortModel> = {
  id: UtilityColumns.SELECTION,
  enableResizing: false,
  meta: {
    defaultWidth: 65,
    blockColumnHiding: true,
    ellipsisOnOverflow: false
  },
  header: ({ table }) => {
    const checked = table.getIsAllRowsSelected();
    const indeterminate = table.getIsSomeRowsSelected();
    const onChange = table.getToggleAllRowsSelectedHandler();
    return <Checkbox onChange={onChange} dashStyle={indeterminate} checked={checked} />;
  },
  cell: ({ row }) => {
    const checked = row.getIsSelected();
    const disabled = !row.getCanSelect();
    const onChange = row.getToggleSelectedHandler();
    return <Checkbox disabled={disabled} checked={checked} onChange={onChange} />;
  }
};
